<!-- Footer inside ion-content -->
<ng-template [ngIf]="config && config.isContentFooter">

  <ion-item-divider [style.bottom]="config.sticky ? '0': ''" [style.position]="config.sticky ? 'fixed': ''"
    [ngClass]="config.class" padding-end padding-start
    class="ion-padding-end ion-padding-start padding-end padding-start">

    <ion-footer>
      <ion-toolbar>
        <ng-template [ngIf]="content">
          <div class="footer-text-wrapper" [froalaView]="content | multiLang | shortCode">
          </div>
        </ng-template>
      </ion-toolbar>
    </ion-footer>

  </ion-item-divider>

</ng-template>

<!-- Footer outside ion-content -->
<!-- <ng-template [ngIf]="config && !config.isContentFooter">
  <ion-footer *ngIf="content">
    <ion-toolbar [froalaView]="content | multiLang">
    </ion-toolbar>
  </ion-footer>
</ng-template> -->